<h2>Property Details</h2>
<div class="containers clearfix">
    <ul>
        <li>
            Survey Number
        </li>
        <li>
            {{PropertyDetails.surveynumber}}&nbsp;
        </li>
        <li>
            Plot/Block/Land Number
        </li>
        <li>
            {{PropertyDetails.landnumber}}&nbsp;
        </li>
        <li>
            Address
        </li>
        <li>
            {{PropertyDetails.buildingname}} <br>
            {{PropertyDetails.streetname}} <br>
            {{PropertyDetails.locality}} <br>
            {{PropertyDetails.landmark}} <br>
            {{PropertyDetails.roadname}} <br>
            Village:&nbsp;{{PropertyDetails.village}} <br>
            Town:&nbsp;{{PropertyDetails.town}} <br>
            City:&nbsp;{{PropertyDetails.city}} <br>
            District:&nbsp;{{PropertyDetails.district}} <br>
            State:&nbsp;{{PropertyDetails.state}} <br>
            Country:&nbsp;{{PropertyDetails.country}} <br>
            Pincode:&nbsp;{{PropertyDetails.pincode}} <br>
        </li>
        <li>
            Location on Map
        </li>
        <li>
            <img src="../../assets/833b6d94-2c36-437f-a1bf-0fa26ee4b79c.svg" style="width: 50px; height: auto; cursor: pointer;" (click)="onMapClicked()"/>
        </li>
    </ul>


</div>



<h2>Property description and adjecent property description</h2>
<div class="containers clearfix">
    <ul>
        <li>
            Property Description
        </li>
        <li>
            {{PropertyDetails.propertydescription}}&nbsp;
        </li>
        <li>
            North
        </li>
        <li>
            {{PropertyDetails.propertynorth}}&nbsp;
        </li>
        <li>
            South
        </li>
        <li>
            {{PropertyDetails.propertysouth}}&nbsp;</li>
        <li>
            East
        </li>
        <li>
            {{PropertyDetails.propertyeast}}&nbsp;
        </li>
        <li>
            West
        </li>
        <li>
            {{PropertyDetails.propertywest}}&nbsp;
        </li>
    </ul>
</div>


<h2>Property Specifications</h2>
<div class="containers clearfix">

    <ul>
        <li>
            Property Type
        </li>
        <li>
            {{ptype.PropertyTypeName}}&nbsp;
        </li>
        <li>
            Area
        </li>
        <li *ngIf="a1">
            {{PropertyDetails.area1}}&nbsp;{{PropertyDetails.area1unit}}&nbsp;
        </li>
        <li *ngIf="a2">
            {{PropertyDetails.area2}}&nbsp;{{PropertyDetails.area2unit}}&nbsp;
        </li>
        <li *ngIf="a3" >
            {{PropertyDetails.area3}}&nbsp;{{PropertyDetails.area3unit}}&nbsp;
        </li>
        <li>
            Area in Sq. Mtrs
        </li>
        <li>
            {{PropertyDetails.areainsqmtr}}&nbsp;Sq. Mtrs.
        </li>
        <li>
            Jurisdiction
        </li>
        <li>
            {{PropertyDetails.jurisdiction}}&nbsp;
        </li>

    </ul>
</div>

<h2>Transaction and value details</h2>
<div class="containers clearfix">
    <ul>
        <li>
            Transaction type
        </li>
        <li>
            {{PropertyFinancial.transactiontype}}&nbsp;
        </li>
        <li>
            Transaction Date
        </li>
        <li>
            {{PropertyFinancial.transactiondate * 1000 | date:'dd/MM/yyyy'}}&nbsp;
        </li>
        <li>
            Previous Jantri
        </li>
        <li>
            {{PropertyFinancial.previousjantri}}&nbsp;
        </li>
        <li>
            Transaction Jantri
        </li>
        <li>
            {{PropertyFinancial.transactionjantri}}&nbsp;
        </li>
        <li>
            Current Jantri
        </li>
        <li>
            {{PropertyFinancial.currentjantri}}&nbsp;
        </li>
        <li>
            Previous Market Value
        </li>
        <li>
            {{PropertyFinancial.previousmarketvalue}}&nbsp;
        </li>

        <li>
            Transaction Value
        </li>
        <li>
            {{PropertyFinancial.transactionmarketvalue}}&nbsp;
        </li>

        <li>
            Current Market Value
        </li>
        <li>
            {{PropertyFinancial.currentmarketvalue}}&nbsp;
        </li>

    </ul>
</div>


<h2>Hypothecation / Mortgage details</h2>
<div class="containers clearfix">
    <ul>
        <li>
            Loan account number
        </li>
        <li>
            {{PropertyFinancial.loanaccountnumber}}&nbsp;
        </li>
        <li>
            Loan Year
        </li>
        <li>
            {{PropertyFinancial.loanyear}}&nbsp;
        </li>
        <li>
            Loan Tenure
        </li>
        <li>
            {{PropertyFinancial.loantenure}}&nbsp;
        </li>
        <li>
            Bank/Lender Name
        </li>
        <li>
            {{PropertyFinancial.lendername}}&nbsp;
        </li>
        <li>
            Loan Amount
        </li>
        <li>
            {{PropertyFinancial.loanamount}}&nbsp;
        </li>
        <li>
            Name of borrowers / Co-borrowers
        </li>
        <li>
            <div *ngFor="let b of PropertyFinancial.borrowers">{{b.borrowername}}</div>
        </li>
        <li>
            Mortgage Deed Number
        </li>
        <li>
            {{PropertyFinancial.mortgagedeednumber}}&nbsp;
        </li>
        <li>
            Lease Agreement Number
        </li>
        <li>
            {{PropertyFinancial.leaseagreementnumber}}&nbsp;
        </li>

    </ul>
</div>

<div>
<input type="button" class="appButton center" style="display: block; width: 500px;" value="View / Share Property Summary Sheet" (click)="onSummarySheet()">
</div>